import { api } from '../../config/ApiConfig';

export const LikeUris = {
  like: (data) => api.post('/v1/users/like_uris', data),
  dislike: (id) => api.delete(`/v1/users/like_uris/${id}`),
}